import Swal from "sweetalert2";
import faradayApi from "../../api/faradayApi"


export const createFundDistribution = async (formValues, succesMsg, errorMsg, navigate) => {
    try {
        const { data } = await faradayApi.post('/fundDistributions', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            navigate(-1)
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: error,
                icon: "error",
                iconColor: '#FF7765'
            })
    }
}

export const editFundDistribution = async (formValues, succesMsg, errorMsg) => {
    try {
        const { data } = await faradayApi.put(`/fundDistributions`, formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })
    }
}

export const deleteFundDistribution = async (e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm) => {
    const {value} = await Swal.fire({
        text: `${deleteConfirm} ${e.row.startup}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
      })
    value && onConfirm(e.row.id, succesMsg, errorMsg, e.row.startup)
}

const onConfirm = async (id, succesMsg, errorMsg, startup) => {
    const { data } = await faradayApi.delete('/fundDistributions', { data: { id } });

        data.data !== 0 && !data.error  ?
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${startup} ${succesMsg}`,
                icon: "success",
            })
            :
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
            })       
}